<template>
  <chart
    ref="chart"
    :width="width"
    :height="height"
    autoresize
  />
</template>

<script>
import { Doughnut } from 'vue-chartjs'

export default {
  components: {
    chart: Doughnut
  },
  props: {
    width: {type: Number, default: 100},
    height: {type: Number, default: 100},
    labels: {type: Array, default: ['A', 'B']},
    data: {type: Array, default: [50, 50]},
  },
  data() {
    return {
      trans: trans,
      numeral: numeral,
    }
  },
  methods: {
    render() {
      if (this.data == null) return
      this.$refs.chart.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            backgroundColor: ['#28a745', '#ddd'],
          },
        ]
      }, {
        responsive: false,
        maintainAspectRatio: true,
        title: {
          display: false,
        },
        legend: {
          display: false
        },
        animation: {
          onProgress: function(chartElement) {
            let data = chartElement.chart.data.datasets[0].data
            let total = data[0] + data[1]
            let filled = data[0]
            let ratio = total > 0 ? filled/total : null
            let value = ratio != null ? Math.round(ratio*100) + '%' : null;
            if (value) {
              let ctx = chartElement.chart.ctx
              ctx.font = '16px sans-serif'
              ctx.textBaseline = 'middle'
              ctx.textAlign = 'center'
              ctx.fillText(value, 50, 50)
            }
          }
        }
      })
    },
  },
  mounted() {
    this.render()
  }
}
</script>